module.exports = __webpack_public_path__ + "img/mono_22.20bc0e2f.png";